<template>
  <div class="mainbg">

    <el-row class="homebg">
      <div class="herade">
        <span>智享伴学自习室分布图</span>
      </div>
      <nav :class="['dd-nav', shownav ? 'show' : '']" @mouseleave="mouseleave" @mouseenter="mouseenter">
        <ul>
          <li v-if="userinfo.role.indexOf('首页') > -1" >
            <el-tooltip class="item" effect="dark" content="首页" placement="left">
              <a>
                <span @click="selectmenu = 'index'" class="icon iconfont">&#xe653;</span>

              </a>
            </el-tooltip>
          </li>
          <li v-if="userinfo.role.indexOf('客户管理') > -1">
            <el-tooltip class="item" effect="dark" content="客户管理" placement="left">
              <a>
                <span @click="selectmenu = 'qiyeguanli'" class="icon iconfont">&#xe637;</span>

              </a>
            </el-tooltip>
          </li>

          <li v-if="userinfo.role.indexOf('系统日志') > -1">
            <el-tooltip class="item" effect="dark" content="系统日志" placement="left">
              <a>
                <span @click="selectmenu = 'syslog'" class="icon iconfont">&#xe63e;</span>

              </a>
            </el-tooltip>
          </li>
          <li v-if="userinfo.role.indexOf('系统管理') > -1">
            <el-tooltip class="item" effect="dark" content="系统管理" placement="left">
              <a>
                <span @click="selectmenu = 'usersys'" class="icon iconfont">&#xe647;</span>

              </a>
            </el-tooltip>
          </li>
        </ul>
      </nav>
      <el-row>


        <el-col :span="24" class="userinfo">
          <span class="nowtime">{{ nowDate }}</span>

          <i class="fenge"></i>

          <span style="cursor: default;">{{userinfo.username}} 您好！</span>
          <i class="fenge"></i>
          <span style="color:#26c0fc" @click="()=>{this.modifypwd = true}">修改密码</span>
          <i class="fenge"></i>
          <span @click="logout" style="color:#26c0fc">退出登录</span>
        </el-col>


      </el-row>
      <el-col :span="24" style="">
        <component v-bind:is="selectmenu"></component>
      </el-col>

      <el-dialog title="" :visible.sync="modifypwd" width="30%" :close-on-click-modal="false"
        :close-on-press-escape="false" :show-close="false">
        <el-row style="    margin-top: -40px;">
          <el-col :span="24" class="stoptitle">
            修改密码
          </el-col>
          <el-col :span="24" style="margin-top:10px">
            <el-form :model="modifypwdMolde" :rules="modifypwdRules" ref="modifypwdForm" label-width="100px">
              <el-form-item label="旧密码" prop="oldpwd">
                <el-input type="password" v-model="modifypwdMolde.oldpwd"></el-input>
              </el-form-item>
              <el-form-item label="新密码" prop="newpwd">
                <el-input type="password" v-model="modifypwdMolde.newpwd"></el-input>
              </el-form-item>
              <el-form-item label="确认密码" prop="newpwd1">
                <el-input type="password" v-model="modifypwdMolde.newpwd1"></el-input>
              </el-form-item>

            </el-form>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button @click="modifypwd = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('modifypwdForm')">确 定</el-button>
        </span>
      </el-dialog>

      <div class="shuiyin">
        <ul>
          <li v-for="(item) in 100" :key="item">
            {{userinfo.username}} - {{nowDate}}
          </li>
        </ul>
      </div>
    </el-row>

  </div>
</template>
<script>
export default {
  components: {
    index: () => import('../components/index'),
    qiyeguanli: () => import('../components/qiyeguanli'),
    shebeigl: () => import('../components/shebeigl'),
    syslog: () => import('../components/syslog'),
    usersys: () => import('../components/usersys'),
  },
  data() {
    return {

      selectmenu: "index",
      modifypwd: false,
      modifypwdMolde: {
        oldpwd: '',
        newpwd: '',
        newpwd1: ''
      },
      modifypwdRules: {
        oldpwd: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
          { min: 6, max: 24, message: '长度在 6 到 24 个字符', trigger: 'blur' }
        ],
        newpwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 24, message: '长度在 6 到 24 个字符', trigger: 'blur' }
        ],
        newpwd1: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { min: 6, max: 24, message: '长度在 6 到 24 个字符', trigger: 'blur' }
        ],
      },
      form: {
        region: "1"
      },
      nowDate: ' - ',
      datetimer: null,
      shownav: false,
      showtimer: null,
      userinfo: null
    }
  },
  created() {

    this.selectmenu = sessionStorage.getItem("selectmenu") || 'index';

    this.userinfo = JSON.parse(sessionStorage.getItem("user"));

    console.log(this.userinfo);

    // if (this.selectmenu) {
    //   this.$router.push({ path: '/home' });

    // }

    this.currentTime();
    this.shownav = true;
    let that = this;

    this.showtimer = setTimeout(() => {
      that.shownav = false;
    }, 5000)
  },
  methods: {

    backhome() {
      this.$router.push({ path: '/index' });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
           
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    logout() {
      this.$confirm("确认要退出系统吗？ 是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$message({
            message: "退出成功！",
            type: "success"
          });
          sessionStorage.clear();
          this.$router.push({ path: '/login' });
        })
        .catch(() => { });
    },
    currentTime() {
      this.datetimer = setInterval(this.formatDate, 1000);
    },
    formatDate() {
      let date = new Date();
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; // 月
      let day = date.getDate(); // 日
      let week = date.getDay(); // 星期
      let weekArr = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
      let hour = date.getHours(); // 时
      hour = hour < 10 ? "0" + hour : hour; // 如果只有一位，则前面补零
      let minute = date.getMinutes(); // 分
      minute = minute < 10 ? "0" + minute : minute; // 如果只有一位，则前面补零
      let second = date.getSeconds(); // 秒
      second = second < 10 ? "0" + second : second; // 如果只有一位，则前面补零
      this.nowDate = `${year}/${month}/${day} ${hour}:${minute}:${second} ${weekArr[week]}`;
    },
    mouseenter() {
      this.shownav = true;
      clearTimeout(this.showtimer);
    },
    mouseleave() {
      let that = this;
      this.showtimer = setTimeout(() => {
        that.shownav = false;
      }, 5000)
    }

  },
  beforeDestroy() {
    if (this.datetimer) {
      clearInterval(this.datetimer); // 在Vue实例销毁前，清除时间定时器
    }
  }
}
</script>
<style scoped>
.herade {

  z-index: 101;
  font-size: 28px;
  font-weight: 700;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: absolute;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  top: 0;
  min-width: 1036px;
  height: 86px;

  color: #fff;
  background-image: url(../assets/home/header-border.png);
  pointer-events: none;
}
</style>
<style>
.logoinfo .el-form-item__content {
  display: inline-block;
  margin-left: 0px !important;
}

.logoinfo .el-form-item {
  display: inline-block;
}

.logoinfo .el-form {
  display: inline-block;
  margin-top: 5px;

  position: absolute;
}

.logoinfo .el-form-item__label {
  color: #fff;
}

.logoinfo .el-select {
  width: 192px;
  padding: 0 0 0 4px;
  border-left: 6px solid #fff;
}
</style>
<style scoped>
.mainbg {
  /* background: url(../assets/home/bg.jpg); */
  height: 100%;
  width: 100%;
  background: #16253c;


}

.homebg {
  /* background: url(../assets/home/headbg.png); */
  height: 86px;
  width: 100%;
  background-size: cover;

}

.logoinfo {
  height: 40px;
  line-height: 40px;
  vertical-align: middle;
  padding-left: 20px;
  user-select: none;
  margin-left: -11px;
  padding-top: 25px;

}

.logoinfo img {
  vertical-align: middle;
}

.logoinfo span {
  font-size: 20px;
  vertical-align: middle;
  color: #fff;
  font-weight: bold;
}

.userinfo {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding-right: 20px;
  color: #fff;
  user-select: none;
  position: inherit;
  z-index: 9999;
}

.userinfo span {
  cursor: pointer;
}

.modelinfo {
  height: 36px;
  text-align: right;
  padding-top: 12px;
}

.modelinfo .models {
  display: block;
  padding: 0 28px 0 24px;

  font-size: 16px;
  line-height: 36px;
  color: #fff;
  text-align: center;
  background: rgba(0, 217, 255, .15);
  width: fit-content;
  position: absolute;
  right: 0;
  z-index: 102;
}

.modelinfo .models>a {
  position: relative;
  display: inline-block;
  padding: 0 12px;
  color: hsla(0, 0%, 100%, .3);
  cursor: pointer;
}

.modelinfo .models>a.dd-this {
  color: #fff;
  font-weight: bold;
}

.modelinfo .models>a:not(:last-child):after {
  position: absolute;
  top: 10px;
  right: 1px;
  bottom: 10px;
  width: 2px;
  content: "";
  background: hsla(0, 0%, 100%, .4);
}


.homeinfo {
  line-height: 30px;
  height: 30px;
  vertical-align: middle;
  color: #fff;
  font-size: 16px;
  padding-left: 20px;
  user-select: none;
}

.homeinfo span,
.homeinfo img {
  vertical-align: middle;
  cursor: pointer;
}

.nowtime {
  color: #00d5d1;
}

.userinfo .fenge{
  display: inline-block;
  height: 20px;
  width: 0;
  border-left: 3px solid #00d5d1;
  margin-left: 10px;
  margin-right: 10px;
  vertical-align: middle;
}

.shuiyin{
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0px;
  top: 0px;
  background-color: transparent;
  z-index: 999;
  pointer-events: none;
}

.shuiyin>ul>li{
  color: #3c434d;
  pointer-events: none;
  user-select: none;
  display: inline-block;
  line-height: 100px;
  height: 100px;
  width: 20%;
  margin-left: 5%;
  transform: rotate(-25deg);
}
</style>